import { useState } from 'react'
import ProductList from './ProductList'
import SortCategory from './SortCategory'
// import { products } from './ContentTemplate'
// import products from '../../data/products.json'
import useFetch from '../../hooks/useFetch'
// import useFetchData from '../../hooks/useFetchData'


const ShopList = () => {

    const { data: products, error,  isLoading} = useFetch('https://francebeam.github.io/clotheapi/products.json')


    const [selectedCategory, setSelectedCategory] = useState('All')
    
    const handleCategoryClick = (category) => {
        setSelectedCategory(category)
    }

    const handleCategorySelect = (event) => {
        setSelectedCategory(event.target.value)

    }


  return (
    <>
        <div className='w-full h-full py-2 p-3'>
            <div className='max-w-[1280px] m-auto lg:p-0'>
                <SortCategory 
                    selectedCategory={selectedCategory}
                    handleCategoryClick={handleCategoryClick}
                    handleCategorySelect={handleCategorySelect}
                    />

                <div className='flex items-center gap-3 mt-10'>
                    <h1 className='uppercase font-bold text-1xl text-black bg-pink p-2 px-4'>
                        Shop {selectedCategory} Clothes:
                    </h1>
                    <svg fill="#000000" version="1.1" id="Capa_1" width="64px" height="64px" viewBox="0 0 41.883 41.883">
                        <g>
                            <path d="M14.257,14.479h-0.516l0.775-2.219h0.636c0.468,0,0.58,0.264,0.37,0.864l-0.164,0.468
                            C15.125,14.261,14.75,14.479,14.257,14.479z M21.426,22.048c-0.42,0-0.764,0.229-0.974,0.828l-1.585,4.532
                            c-0.21,0.601-0.025,0.828,0.395,0.828c0.42,0,0.763-0.229,0.973-0.828l1.585-4.532C22.029,22.277,21.846,22.048,21.426,22.048z
                            M14.15,17.429l0.255-0.731c0.273-0.78,0.104-1.02-0.495-1.02h-0.588l-0.901,2.579h0.756C13.62,18.255,13.931,18.051,14.15,17.429z
                            M40.521,24.852c0.493,0.758,0.616,1.698,0.337,2.561c-0.278,0.861-0.932,1.549-1.776,1.873l-4.353,1.673l-0.245,4.655
                            c-0.048,0.904-0.501,1.738-1.232,2.271c-0.732,0.533-1.666,0.705-2.539,0.472l-4.504-1.207l-2.936,3.623
                            c-0.569,0.703-1.426,1.111-2.331,1.111s-1.761-0.408-2.331-1.111l-2.935-3.623l-4.503,1.207c-0.875,0.233-1.807,0.062-2.54-0.472
                            c-0.732-0.532-1.185-1.366-1.233-2.271l-0.245-4.655l-4.352-1.673c-0.845-0.323-1.498-1.012-1.777-1.873
                            c-0.28-0.86-0.156-1.801,0.337-2.561l2.539-3.911l-2.539-3.91c-0.493-0.759-0.617-1.7-0.337-2.561
                            c0.279-0.861,0.932-1.549,1.777-1.874l4.352-1.672L7.401,6.27C7.448,5.366,7.901,4.533,8.633,4
                            c0.732-0.531,1.667-0.703,2.539-0.471l4.503,1.205l2.936-3.623C19.181,0.408,20.037,0,20.942,0s1.762,0.408,2.331,1.111
                            l2.936,3.623l4.504-1.206c0.875-0.233,1.808-0.061,2.539,0.471c0.73,0.532,1.185,1.366,1.231,2.27l0.245,4.655l4.354,1.672
                            c0.844,0.324,1.498,1.013,1.775,1.874c0.28,0.86,0.156,1.801-0.337,2.561l-2.539,3.91L40.521,24.852z M27.969,12.258l-2.518,7.196
                            h1.319l2.517-7.196h1.381l0.418-1.199H27.01l-0.42,1.199H27.969z M22.033,13.074c-0.838,2.398,1.626,2.722,1.022,4.449
                            c-0.21,0.6-0.55,0.816-0.97,0.816s-0.607-0.216-0.397-0.816l0.208-0.6h-1.247l-0.18,0.516c-0.469,1.343-0.066,2.11,1.229,2.11
                            c1.295,0,2.235-0.768,2.705-2.11c0.841-2.399-1.626-2.723-1.022-4.45c0.211-0.6,0.531-0.828,0.949-0.828
                            c0.42,0,0.58,0.229,0.369,0.828l-0.119,0.348h1.245l0.095-0.264c0.47-1.343,0.078-2.111-1.205-2.111S22.504,11.732,22.033,13.074z
                            M18.49,11.06l-2.936,8.396h3.598l0.419-1.199h-2.279l0.86-2.459h1.811l0.419-1.199h-1.811l0.817-2.339h2.279l0.42-1.199
                            L18.49,11.06L18.49,11.06z M10.682,19.456h2.075c1.319,0,2.246-0.696,2.699-1.991l0.239-0.684c0.311-0.888,0.257-1.523-0.354-1.799
                            c0.684-0.276,1.141-0.828,1.443-1.691l0.104-0.3c0.453-1.295,0.088-1.931-1.279-1.931h-1.991L10.682,19.456z M11.756,27.326
                            l0.39-1.115h-1.248l-0.419,1.199c-0.21,0.6-0.549,0.816-0.969,0.816c-0.419,0-0.608-0.218-0.398-0.816l1.585-4.533
                            c0.21-0.6,0.554-0.828,0.974-0.828s0.604,0.229,0.394,0.828l-0.314,0.898h1.248l0.285-0.814c0.47-1.344,0.066-2.111-1.229-2.111
                            c-1.295,0-2.236,0.767-2.706,2.111l-1.526,4.365c-0.47,1.344-0.066,2.111,1.229,2.111C10.346,29.438,11.287,28.67,11.756,27.326z
                            M16.019,29.34l2.936-8.396h-1.343l-1.258,3.598h-1.5l1.258-3.598h-1.319l-2.936,8.396h1.319l1.258-3.6h1.5l-1.258,3.6H16.019z
                            M21.585,27.326l1.524-4.365c0.472-1.344,0.031-2.111-1.266-2.111c-1.294,0-2.271,0.767-2.74,2.111l-1.526,4.365
                            c-0.47,1.344-0.03,2.111,1.265,2.111S21.114,28.67,21.585,27.326z M25.987,20.944h-1.318l-2.936,8.396h1.318L25.987,20.944z
                            M28.447,27.326c0.839-2.398-1.626-2.723-1.021-4.449c0.209-0.6,0.529-0.828,0.947-0.828c0.42,0,0.58,0.229,0.369,0.828
                            l-0.119,0.348h1.246l0.094-0.264c0.47-1.344,0.078-2.111-1.205-2.111s-2.211,0.767-2.683,2.111
                            c-0.839,2.398,1.627,2.723,1.022,4.449c-0.21,0.6-0.55,0.816-0.97,0.816c-0.418,0-0.607-0.218-0.397-0.816l0.209-0.6h-1.247
                            l-0.18,0.516c-0.471,1.344-0.067,2.111,1.229,2.111S27.978,28.67,28.447,27.326z M35.034,20.944h-3.599L28.5,29.34h3.599
                            l0.419-1.197h-2.278l0.859-2.459h1.811l0.42-1.199h-1.812l0.818-2.338h2.276L35.034,20.944z"/>
                        </g>
                    </svg>
                </div>
                <div className='w-full gap-9 py-16 grid grid-cols-2 max-w-[1280px] m-auto justify-center md:grid-cols-3 lg:grid-cols-4'>

                    { error && <div className='text-red'>Can't fetch data from resources</div>}
                    <ProductList 
                        products={products}
                        selectedCategory={selectedCategory}
                        handleCategorySelect={handleCategorySelect}
                            /> 
                </div>
            </div>
        </div>
    </>
  )
}

export default ShopList